/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout(() => {
        this.buttons = Array.from(this.querySelectorAll('button'));
        this.links = this.closest('.section-header').querySelectorAll('.linked-to-tab');
        this.target = this.dataset.target;

        const section = this.closest('.collection-tabs');
        const viewAllBtn = section.querySelector('.collection-view-all-btn');

        this.buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {

            let handle = button.dataset.collection;

            // 🔄 remove active from all buttons
            this.buttons.forEach(el => el.classList.remove('active'));

            // 🔄 remove active from header links
            if (this.links.length) {
              this.links.forEach(el => el.classList.remove('active'));
              this.links[i].classList.add('active');
            }

            // ✅ set active
            button.classList.add('active');

            // ✅ change products
            if (handle) {
              this.toggleCollection(handle);
            }

            // ✅ UPDATE VIEW ALL BUTTON (MAIN FIX)
            if (viewAllBtn && handle) {
              viewAllBtn.href = '/collections/' + handle;
            }

            event.preventDefault();
          });
        });

        // ✅ SET DEFAULT LINK ON LOAD
        const activeBtn = this.querySelector('button.active') || this.buttons[0];
        if (activeBtn && viewAllBtn) {
          viewAllBtn.href = '/collections/' + activeBtn.dataset.collection;
        }

      }, 10);

      // Shopify editor support
      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          let index = this.buttons.indexOf(event.target);
          this.buttons[index].dispatchEvent(new Event('click'));
        });
      }
    }

    toggleCollection(handle) {
      let slider = document.getElementById(this.target),
        products = slider.querySelectorAll(`.columns:not([data-collection="${handle}"])`),
        active_products = slider.querySelectorAll(`[data-collection="${handle}"]`),
        flkty = Flickity.data(slider);

      products.forEach(el => {
        el.classList.remove('carousel__slide');
        slider.append(el);
      });

      active_products.forEach(el => {
        el.classList.add('carousel__slide');
      });

      flkty.insert(active_products);
      flkty.reloadCells();
      flkty.select(0, 0, 1);
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}